var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16838_58825",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99999 1.16797C3.77999 1.16797 1.16666 3.7813 1.16666 7.0013C1.16666 10.2213 3.77999 12.8346 6.99999 12.8346C10.22 12.8346 12.8333 10.2213 12.8333 7.0013C12.8333 3.7813 10.22 1.16797 6.99999 1.16797ZM6.99999 9.91797C6.67916 9.91797 6.41666 9.65547 6.41666 9.33464V7.0013C6.41666 6.68047 6.67916 6.41797 6.99999 6.41797C7.32082 6.41797 7.58332 6.68047 7.58332 7.0013V9.33464C7.58332 9.65547 7.32082 9.91797 6.99999 9.91797ZM6.41666 5.2513H7.58332V4.08464H6.41666V5.2513Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16838_58825)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#F99E00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.7ddab92d0290392c2ec279c9da083f07.svg";
export { ForwardRef as ReactComponent };